import React, { useState, useContext, useEffect, useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import DynamicLayout from "../../components/DynamicLayout";
import CourseHero from "../../components/CourseHero";
import IntroductionTreeOfLife from "../lessons/numerology/chapter1/introductiontreeoflife";
import IntroductionSephiroth from "../lessons/numerology/chapter1/introductionsephiroth";
import IntroductionPaths from "../lessons/numerology/chapter1/introductionpaths";
import Kether from "../lessons/numerology/chapter2/kether";
import Chokmah from "../lessons/numerology/chapter2/chokmah";
import Binah from "../lessons/numerology/chapter2/binah";
import Chesed from "../lessons/numerology/chapter2/chesed";
import Geburah from "../lessons/numerology/chapter2/geburah";
import Tiphareth from "../lessons/numerology/chapter2/tiphareth";
import Netzach from "../lessons/numerology/chapter2/netzach";
import Hod from "../lessons/numerology/chapter2/hod";
import Yesod from "../lessons/numerology/chapter2/yesod";
import Malkuth from "../lessons/numerology/chapter2/malkuth";
import Path1 from "../lessons/numerology/chapter3/path1";
import Path2 from "../lessons/numerology/chapter3/path2";
import Path3 from "../lessons/numerology/chapter3/path3";
import Path4 from "../lessons/numerology/chapter3/path4";
import Path5 from "../lessons/numerology/chapter3/path5";
import Path6 from "../lessons/numerology/chapter3/path6";
import Path7 from "../lessons/numerology/chapter3/path7";
import Path8 from "../lessons/numerology/chapter3/path8";
import Path9 from "../lessons/numerology/chapter3/path9";
import Path10 from "../lessons/numerology/chapter3/path10";
import Path11 from "../lessons/numerology/chapter3/path11";
import Path12 from "../lessons/numerology/chapter3/path12";
import Path13 from "../lessons/numerology/chapter3/path13";
import Path14 from "../lessons/numerology/chapter3/path14";
import Path15 from "../lessons/numerology/chapter3/path15";
import Path16 from "../lessons/numerology/chapter3/path16";
import Path17 from "../lessons/numerology/chapter3/path17";
import Path18 from "../lessons/numerology/chapter3/path18";
import Path19 from "../lessons/numerology/chapter3/path19";
import Path20 from "../lessons/numerology/chapter3/path20";
import Path21 from "../lessons/numerology/chapter3/path21";
import Path22 from "../lessons/numerology/chapter3/path22";


import { AcademyContext } from "../../context/academyContext";

const INTRODUCTION_LESSONS = [
  { value: 1, label: "Lesson 1: Tree of Life" },
  { value: 2, label: "Lesson 2: Sephiroth" },
  { value: 3, label: "Lesson 3: Paths" },
];

const SEPHIROT_LESSONS = [
  { value: 4, label: "Lesson 4: Kether" },
  { value: 5, label: "Lesson 5: Chokmah" },
  { value: 6, label: "Lesson 6: Binah" },
  { value: 7, label: "Lesson 7: Chesed" },
  { value: 8, label: "Lesson 8: Geburah" },
  { value: 9, label: "Lesson 9: Tiphareth" },
  { value: 10, label: "Lesson 10: Netzach" },
  { value: 11, label: "Lesson 11: Hod" },
  { value: 12, label: "Lesson 12: Yesod" },
  { value: 13, label: "Lesson 13: Malkuth" },
];

const PATH_LESSONS = [
  { value: 14, label: "Lesson 14: Path 1 - Kether to Chokmah" },
  { value: 15, label: "Lesson 15: Path 2 - Kether to Binah" },
  { value: 16, label: "Lesson 16: Path 3 - Chokmah to Binah" },
  { value: 17, label: "Lesson 17: Path 4 - Chokmah to Chesed" },
  { value: 18, label: "Lesson 18: Path 5 - Binah to Geburah" },
  { value: 19, label: "Lesson 19: Path 6 - Chesed to Tiphareth" },
  { value: 20, label: "Lesson 20: Path 7 - Geburah to Tiphareth" },
  { value: 21, label: "Lesson 21: Path 8 - Tiphareth to Netzach" },
  { value: 22, label: "Lesson 22: Path 9 - Tiphareth to Hod" },
  { value: 23, label: "Lesson 23: Path 10 - Netzach to Yesod" },
  { value: 24, label: "Lesson 24: Path 11 - Hod to Yesod" },
  { value: 25, label: "Lesson 25: Path 12 - Yesod to Malkuth" },
  { value: 26, label: "Lesson 26: Path 13 - Kether to Tiphareth" },
  { value: 27, label: "Lesson 27: Path 14 - Chokmah to Tiphareth" },
  { value: 28, label: "Lesson 28: Path 15 - Binah to Tiphareth" },
  { value: 29, label: "Lesson 29: Path 16 - Chesed to Netzach" },
  { value: 30, label: "Lesson 30: Path 17 - Geburah to Hod" },
  { value: 31, label: "Lesson 31: Path 18 - Netzach to Malkuth" },
  { value: 32, label: "Lesson 32: Path 19 - Hod to Malkuth" },
  { value: 33, label: "Lesson 33: Path 20 - Tiphareth to Yesod" },
  { value: 34, label: "Lesson 34: Path 21 - Netzach to Hod" },
  { value: 35, label: "Lesson 35: Path 22 - Yesod to Malkuth" },
];

const LESSON_SECTIONS = [
  { chapter: "Chapter 1: Introduction to Qabalistic Numerology", lessons: INTRODUCTION_LESSONS },
  { chapter: "Chapter 2: The Sephirot", lessons: SEPHIROT_LESSONS },
  { chapter: "Chapter 3: The Paths and Numbers", lessons: PATH_LESSONS },
];

const LESSON_METADATA = LESSON_SECTIONS.reduce((map, section) => {
  section.lessons.forEach(({ value, label }) => {
    const shortLabel = label.includes(": ") ? label.split(": ").slice(1).join(": ") : label;
    map[value] = { chapter: section.chapter, lesson: shortLabel };
  });
  return map;
}, {});

const DEFAULT_LESSON_INFO = {
  chapter: "Numerology Course",
  lesson: "Choose a lesson to begin",
};

const TOTAL_NUMEROLOGY_LESSONS = PATH_LESSONS[PATH_LESSONS.length - 1].value;

const NumerologyLessonPage = () => {
  const { progress, updateCourseProgress } = useContext(AcademyContext);
  const numerologyCompleted = progress.numerology?.completedLessons || 0;
  const [currentLesson, setCurrentLesson] = useState(
    Math.min(numerologyCompleted + 1, TOTAL_NUMEROLOGY_LESSONS)
  );
  const [showHero, setShowHero] = useState(true);
  const [isAnimating, setIsAnimating] = useState(false);
  const { level = "beginner" } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    setCurrentLesson(
      Math.min(
        (progress.numerology?.completedLessons || 0) + 1,
        TOTAL_NUMEROLOGY_LESSONS
      )
    );
  }, [progress.numerology?.completedLessons]);

  const lessonInfo = useMemo(
    () => LESSON_METADATA[currentLesson] || DEFAULT_LESSON_INFO,
    [currentLesson]
  );

  const lessonOptions = useMemo(
    () => (
      <>
        {LESSON_SECTIONS.map((section) => (
          <optgroup key={section.chapter} label={section.chapter}>
            {section.lessons.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </optgroup>
        ))}
      </>
    ),
    []
  );

  const isIntermediateUnlocked = numerologyCompleted >= TOTAL_NUMEROLOGY_LESSONS;

  // Correctly render the lesson based on `currentLesson` value
const renderLesson = () => {
    switch (currentLesson) {
      case 1:
        return <IntroductionTreeOfLife onNextLesson={handleNext} markLessonComplete={markLessonComplete} />;
      case 2:
        return <IntroductionSephiroth onNextLesson={handleNext} markLessonComplete={markLessonComplete} />;
      case 3:
        return <IntroductionPaths onNextLesson={handleNext} markLessonComplete={markLessonComplete} />;
      case 4:
        return <Kether onNextLesson={handleNext} markLessonComplete={markLessonComplete} />;
      case 5:
        return <Chokmah onNextLesson={handleNext} markLessonComplete={markLessonComplete} />;
      case 6:
        return <Binah onNextLesson={handleNext} markLessonComplete={markLessonComplete} />;
      case 7:
        return <Chesed onNextLesson={handleNext} markLessonComplete={markLessonComplete} />;
      case 8:
        return <Geburah onNextLesson={handleNext} markLessonComplete={markLessonComplete} />;
      case 9:
        return <Tiphareth onNextLesson={handleNext} markLessonComplete={markLessonComplete} />;
      case 10:
        return <Netzach onNextLesson={handleNext} markLessonComplete={markLessonComplete} />;
      case 11:
        return <Hod onNextLesson={handleNext} markLessonComplete={markLessonComplete} />;
      case 12:
        return <Yesod onNextLesson={handleNext} markLessonComplete={markLessonComplete} />;
      case 13:
        return <Malkuth onNextLesson={handleNext} markLessonComplete={markLessonComplete} />;
      case 14:
        return <Path1 onNextLesson={handleNext} markLessonComplete={markLessonComplete} />;
      case 15:
        return <Path2 onNextLesson={handleNext} markLessonComplete={markLessonComplete} />;
      case 16:
        return <Path3 onNextLesson={handleNext} markLessonComplete={markLessonComplete} />;
      case 17:
        return <Path4 onNextLesson={handleNext} markLessonComplete={markLessonComplete} />;
      case 18:
        return <Path5 onNextLesson={handleNext} markLessonComplete={markLessonComplete} />;
      case 19:
        return <Path6 onNextLesson={handleNext} markLessonComplete={markLessonComplete} />;
      case 20:
        return <Path7 onNextLesson={handleNext} markLessonComplete={markLessonComplete} />;
      case 21:
        return <Path8 onNextLesson={handleNext} markLessonComplete={markLessonComplete} />;
      case 22:
        return <Path9 onNextLesson={handleNext} markLessonComplete={markLessonComplete} />;
      case 23:
        return <Path10 onNextLesson={handleNext} markLessonComplete={markLessonComplete} />;
      case 24:
        return <Path11 onNextLesson={handleNext} markLessonComplete={markLessonComplete} />;
      case 25:
        return <Path12 onNextLesson={handleNext} markLessonComplete={markLessonComplete} />;
      case 26:
        return <Path13 onNextLesson={handleNext} markLessonComplete={markLessonComplete} />;
      case 27:
        return <Path14 onNextLesson={handleNext} markLessonComplete={markLessonComplete} />;
      case 28:
        return <Path15 onNextLesson={handleNext} markLessonComplete={markLessonComplete} />;
      case 29:
        return <Path16 onNextLesson={handleNext} markLessonComplete={markLessonComplete} />;
      case 30:
        return <Path17 onNextLesson={handleNext} markLessonComplete={markLessonComplete} />;
      case 31:
        return <Path18 onNextLesson={handleNext} markLessonComplete={markLessonComplete} />;
      case 32:
        return <Path19 onNextLesson={handleNext} markLessonComplete={markLessonComplete} />;
      case 33:
        return <Path20 onNextLesson={handleNext} markLessonComplete={markLessonComplete} />;
      case 34:
        return <Path21 onNextLesson={handleNext} markLessonComplete={markLessonComplete} />;
      case 35:
        return <Path22 onNextLesson={handleNext} markLessonComplete={markLessonComplete} />;
      default:
        return <IntroductionTreeOfLife onNextLesson={handleNext} markLessonComplete={markLessonComplete} />;
    }
  };
  
  const handleNext = () => {
    setCurrentLesson((prevLesson) =>
      prevLesson < TOTAL_NUMEROLOGY_LESSONS ? prevLesson + 1 : prevLesson
    );
  };

  const handlePrevious = () => {
    if (currentLesson > 1) {
      setCurrentLesson((prevLesson) => prevLesson - 1);
    }
  };

  const markLessonComplete = async () => {
    await updateCourseProgress(
      "numerology",
      Math.max(numerologyCompleted, currentLesson)
    );
  };

  const handleLessonChange = (event) => {
    setCurrentLesson(Number(event.target.value));
  };

  const handleLevelChange = (newLevel) => {
    navigate(`/academy/numerology/${newLevel}/lesson?lesson=${currentLesson}`);
  };

  const toggleHero = () => {
    if (isAnimating) {
      return;
    }

    setIsAnimating(true);
    setShowHero(!showHero);

    setTimeout(() => {
      setIsAnimating(false);
    }, 500);
  };

  return (
    <DynamicLayout>
      <CourseHero
        courseTitle="Numerology Course"
        level={level}
        chapter={lessonInfo.chapter}
        lesson={lessonInfo.lesson}
        currentLesson={currentLesson}
        completedLessons={numerologyCompleted}
        totalLessons={TOTAL_NUMEROLOGY_LESSONS}
        completedQuestions={[]}
        maxQuestions={0}
        lessonOptions={lessonOptions}
        onLessonChange={handleLessonChange}
        onLevelChange={handleLevelChange}
        isIntermediateUnlocked={isIntermediateUnlocked}
        showHero={showHero}
        isAnimating={isAnimating}
        onToggleHero={toggleHero}
        currentQuestion={0}
        onQuestionChange={() => {}}
        totalQuestions={0}
      />
      <div className="full-screen-image-container hasbackgroundblack margin-top-0 nomaxheight has-text-centered">
        <section className="container has-text-centered">
          {renderLesson()}
          <div className="container has-text-centered mt-4 mb-6">
            <button
              className="button is-warning mr-2"
              onClick={handlePrevious}
              disabled={currentLesson === 1}
            >
              Previous Lesson
            </button>
            <button
              className="button is-warning"
              onClick={handleNext}
              disabled={currentLesson === TOTAL_NUMEROLOGY_LESSONS}
            >
              Next Lesson
            </button>
          </div>
        </section>
      </div>
    </DynamicLayout>
  );
};

export default NumerologyLessonPage;
